var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('div',{staticClass:"empty_msg"},[_vm._v(_vm._s(_vm.EmptyMsg))]),_c('div',{staticClass:"bottom_button",on:{"click":_vm.clickButton}},[_vm._v(_vm._s(_vm.buttonText))])])}
var staticRenderFns = []

export { render, staticRenderFns }